import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Oppgave } from "../../types/oppgave";
import type { Changelog } from "HNEntities/endringer";
import type { SkjulSamtaleStatus } from "../../enums/skjulSamtaleStatus";

export interface OppgaveDetaljerState {
  oppgave?: Oppgave | null | undefined;
  changelog?: Changelog | null | undefined;
  skjulSamtaleStatus: SkjulSamtaleStatus | null;
  isLoading: boolean;
  hasLoadError: boolean;
  loadErrorStatusCode?: number;
  isPaminnelseEnabled: boolean;
  isLoadingPaminnelse: boolean;
  hasPaminnelseError: boolean;
  resourcesError: string | undefined;
  resourcesLoading: boolean;
  resourcesLoaded: boolean;
}

const initialState: OppgaveDetaljerState = {
  oppgave: null,
  changelog: [],
  skjulSamtaleStatus: null,
  isLoading: false,
  hasLoadError: false,
  loadErrorStatusCode: undefined,
  isPaminnelseEnabled: false,
  isLoadingPaminnelse: false,
  hasPaminnelseError: false,
  resourcesError: undefined,
  resourcesLoading: false,
  resourcesLoaded: false,
};

export const oppgaveDetaljerSlice = createSlice({
  name: "oppgaveDetaljer",
  initialState,
  reducers: {
    setOppgave: (state, action: PayloadAction<Oppgave>) => {
      state.oppgave = action.payload;
      state.isPaminnelseEnabled = action.payload.SendPaminnelse;
      state.isLoading = false;
      state.hasLoadError = false;
      state.loadErrorStatusCode = undefined;
    },
    setChangelog: (state, action: PayloadAction<Changelog>) => {
      state.changelog = action.payload;
      state.isLoading = false;
    },
    clearCurrentOppgave: (state) => {
      state.oppgave = null;
      state.changelog = [];
      state.skjulSamtaleStatus = null;
    },
    setSkjulSamtaleStatus: (
      state,
      action: PayloadAction<SkjulSamtaleStatus | null>,
    ) => {
      state.skjulSamtaleStatus = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.hasLoadError = action.payload;
      if (!action.payload) {
        state.loadErrorStatusCode = undefined;
      }
      state.isLoading = false;
    },
    setErrorStatusCode: (state, action: PayloadAction<number | undefined>) => {
      state.loadErrorStatusCode = action.payload;
    },
    setPaminnelseEnabled: (state, action: PayloadAction<boolean>) => {
      state.isPaminnelseEnabled = action.payload;
      if (state.oppgave) {
        state.oppgave.SendPaminnelse = action.payload;
      }
    },
  },
});

export const {
  setOppgave,
  setChangelog,
  clearCurrentOppgave,
  setSkjulSamtaleStatus,
  setLoading,
  setError,
  setErrorStatusCode,
  setPaminnelseEnabled,
} = oppgaveDetaljerSlice.actions;
export default oppgaveDetaljerSlice.reducer;
